import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { scrubSentryEvent } from './utils/report-api-error';
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sampleRate: 1,
    sendDefaultPii: false,
    beforeSend: scrubSentryEvent,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
